import React from "react";

interface RichTextRendererProps {
  content: string;
  className?: string;
}

const RichTextRenderer: React.FC<RichTextRendererProps> = ({
  content,
  className = "",
}) => {
  if (!content) {
    return null;
  }

  // Process content to ensure links have proper protocols and fix pre/code elements
  const processContent = (htmlContent: string): string => {
    // Create a temporary div to parse and modify the HTML
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlContent;

    // Find all links and ensure they have proper protocols
    const links = tempDiv.querySelectorAll("a");
    links.forEach((link) => {
      const href = link.getAttribute("href");
      if (
        href &&
        !href.startsWith("http://") &&
        !href.startsWith("https://") &&
        !href.startsWith("mailto:") &&
        !href.startsWith("tel:")
      ) {
        link.setAttribute("href", "https://" + href);
      }
    });

    // Fix pre/code elements that contain regular text (not actual code)
    const preElements = tempDiv.querySelectorAll("pre");
    preElements.forEach((pre) => {
      const codeElement = pre.querySelector("code");
      if (codeElement) {
        const text = codeElement.textContent || "";
        // Check if this looks like regular text (not code)
        const isRegularText =
          !text.includes("function") &&
          !text.includes("const ") &&
          !text.includes("let ") &&
          !text.includes("var ") &&
          !text.includes("if (") &&
          !text.includes("for (") &&
          !text.includes("class ") &&
          !text.includes("import ") &&
          !text.includes("export ") &&
          text.length > 20; // Likely regular text if longer than 20 chars

        if (isRegularText) {
          // Replace pre/code with a paragraph
          const p = document.createElement("p");
          p.textContent = text;
          pre.parentNode?.replaceChild(p, pre);
        }
      }
    });

    return tempDiv.innerHTML;
  };

  const processedContent = processContent(content);

  return (
    <div
      className={`rich-text-content ${className}`}
      dangerouslySetInnerHTML={{__html: processedContent}}
    />
  );
};

export default RichTextRenderer;
